<template>
    <div class="tr" v-if="loaded">
        <span :class="{edited: edited}" class="td">{{index}}</span>
        <span class="td"><textarea :placeholder="$t('groups.name')" cols="10" rows="4" type="text"
                                   v-model="name"></textarea></span>
        <span class="td select-container"><MultiSelect :allow-empty="true"
                                                       :deselectLabel="$t('multiselect.deselectLabel')"
                                                       :limit="15"
                                                       :limit-text=" count => `+ ${count}`"
                                                       :maxHeight="200"
                                                       :multiple="true"
                                                       :options="availableShops"
                                                       :placeholder="$t('multiselect.placeholder')"
                                                       :searchable="true"
                                                       :selectLabel="$t('multiselect.selectLabel')"
                                                       :selectedLabel="$t('multiselect.selectedLabel')"
                                                       @input="select"
                                                       @remove="remove"
                                                       class="shop-select"
                                                       label="name"
                                                       track-by="id"
                                                       v-model="initVal"
                                                       :closeOnSelect="false"

        >
       <!-- @select="select"
        @remove="remove"-->
            <template slot="noOptions">{{$t('groups.empty')}}</template>
        </MultiSelect>
        </span>
        <span :class="{edited: edited}" class="td">
            <div class="operations">
                <font-awesome-icon :title="$t('groups.removeAll')" @click="addAll" icon="minus-square"
                                   v-if="initVal.length === availableShops.length"></font-awesome-icon>
                <font-awesome-icon :title="$t('groups.addAll')" @click="addAll" icon="plus-square"
                                   v-else></font-awesome-icon>
          <font-awesome-icon :class="{marked: markedForRemoval}" @click="markForRemoval"
                             class="disabled" icon="times-circle"
                             :title="$t('general.remove')" size="lg" style="cursor: pointer;"/>
                </div>
        </span>
    </div>
</template>

<script>
import MultiSelect from 'vue-multiselect';
import {RepositoryFactory} from '@/api/RepositoryFactory';

const GroupRepository = RepositoryFactory.get('groups');

export default {
  name: 'Group',
  components: {MultiSelect},
  props: {
    group: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  watch: {
    name(newValue, oldValue) {
      if (newValue !== this.startName && this.loaded) {
        this.group.name = newValue;
        this.edited = true;
        this.$emit('edited', this.$vnode.key);
      }
    },
  },

  data() {
    return {
      startName: '',
      startShops: [],
      availableShops: [],
      initVal: [],
      markedForRemoval: false,
      name: '',
      loaded: false,
      newShops: [],
      edited: false,
    };
  },
  methods: {
    addAll() {
      if (this.initVal.length === this.availableShops.length) {
        this.startShops.forEach((value) => {
          this.group.detachShopIds.push(value.id);
        });
        this.initVal = [];
        this.group.newShopsList = [];
      } else {
        this.group.detachShopIds = [];
        this.initVal = this.availableShops;
        this.group.newShopsList = this.initVal;
        this.detachShopIds = [];
      }
      this.edited = true;
      this.$emit('edited', this.$vnode.key);
    },
    inArray(key, array) {
      return (array.indexOf(key) > -1);
    },
    markForRemoval() {
      if (this.group.id > 0) {
        this.markedForRemoval = !this.markedForRemoval;
        this.$emit('remove', this.group.id);
      } else {
        this.$emit('delete', this.$vnode.key);
      }
    },
    getAvailableShops() {
      const {token} = this.$store.getters;
      GroupRepository.getGroupAvailableShops(token, this.group.id)
        .then((response) => {
          response.sort((a, b) => ((a.name.localeCompare(b.name))));
          this.availableShops = [...this.group.shops, ...response];
          this.initVal = this.group.shops;
        });
    },
    select(value, id) {
      const diff = value
        .filter(x => !this.startShops.includes(x))
        .concat(this.startShops.filter(x => !value.includes(x)));
      if (diff.length > 0) {
        this.group.newShopsList = [];
        diff.forEach((val, key) => {
          this.group.newShopsList.push(val);
        });
      }
      this.edited = true;
      this.$emit('edited', this.$vnode.key);
    },
    remove(group) {
      // this.group.newShopsList = this.initVal;
      if (this.group.newShopsList.find(x => x.id === group.id)) {
        this.group.newShopsList.splice(this.group.newShopsList.indexOf(group), 1);
      } else {
        this.group.detachShopIds.push(group.id);
      }
    },
    compare(arr1, arr2) {
      if (!arr1 || !arr2) {
        return;
      }
      let result;
      arr1.forEach((e1, i) => arr2.forEach((e2) => {
        if (e1.length > 1 && e2.length) {
          result = this.compare(e1, e2);
        } else if (e1 !== e2) {
          result = false;
        } else {
          result = true;
        }
      }));
      // eslint-disable-next-line consistent-return
      return result;
    },
  },
  mounted() {
    if (this.group.name !== undefined) {
      this.name = this.group.name;
      this.startName = this.group.name;
    }
    this.getAvailableShops();
    this.startShops = this.group.shops;
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>


    DIV.table {
        display: table;
    }

    FORM.tr, DIV.tr {
        display: table-row;
        /*border: 1px solid lightgray;*/
    }

    SPAN.td {
        display: table-cell;
        padding: 0;
        border-bottom: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        /* color: #878a94; */
        text-align: left;

        &:first-child {
            font-weight: 900;
            padding: 20px;
        }

        &:last-child {
            border-right: none;
        }

        input {
            border: none;
        }
    }

    .a {
        fill: #002678;
    }

    .b {
        fill: #fff;
    }

    svg {
        padding: 0 10px 0 20px;
    }

    .active {
        color: $peacock-blue;
    }

    .disabled {
        color: $marine-blue;
    }

    .td.status {
        text-align: center;
    }

    input {
        /* color: #878a94; */
        font-size: rem(14px);
        line-height: rem(19px);
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }

    .multiselect__tags {
        border: none;
    }

    .marked {
        color: $red;
    }

    .select-container {
        width: 60%;
    }

    .operations {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .edited {
        background-color: #E5E5E5;
    }

    textarea {
        resize: none;
        border: none;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        height: 100%;

        &:focus {
            border: 1px solid $peacock-blue;
        }
    }
</style>
